export default __webpack_public_path__ + "57fcebe1dc27935c103dcef898037179.png";